<script>
    import Project from "./Project.svelte";
    let projectTitle = "FishSET Mapping Interface";
    let projectDescription = "This mapping interface is part of the larger FishSET project which I have been a part of in various roles over some time.  This Javascript tool allows the display of various data on a map, built specifically for fishing data.  The user supplies a CSV of points and a Geojson grid to create a spatial histogram. It displays the fishing locations either as points or as lines for the haul allowing for analysis of fishing based on a variety of variables. Data associated with an individual haul is shown on the map and colored based on the value of a chosen variable associated with that data. The data is also spatially grouped based on the user’s choice of the grid.  Hovering on the haul lines brings up the associated points on the lower temporal graphs as well as any information related to that data point in the text area on the right-hand side. The map is a vector tile map built using Mapbox GL JS library. The graphs at the bottom and the menus and legends were built using D3.js.  The legends are using a library called d3-legend. The code lives on Github as part of the NOAA Fisheries Integrated Toolbox, a project which I coordinate for work.";
</script>
<Project projectTitle = {projectTitle} projectDescription={projectDescription}>
    <section>
     <img src="images/FishSET.png" alt="Mapping Interface for Fisheries">
<div class ="linkToGithub">
    <a href='https://github.com/nmfs-general-modeling-tools/FishSET-Map-Viewer'>FishSET-Map-Viewer</a>
    <a href="https://noaa-fisheries-integrated-toolbox.github.io/">NOAA Fisheries Integrated Toolbox</a>
    </div>
</section>
</Project>
<style>

section{
    justify-content: center;
    align-items: center;
    margin: auto;

    }
    img{max-width: 900px;
    }
.linkToGithub{
    display: flex;
    flex-direction: row;
    padding:5px;
    justify-content: space-evenly;

}
     a{
        font-style:  italic;
        color: white;
        justify-content: flex-start;
        padding:5px;

    }

    @media (max-width: 900px) {
       img{width:100vw;}


    }

</style>